export default [
  {
    path: '/manage',
    name: 'Manage',
    component: () => import(/* webpackChunkName: "manage" */ '@/views/Manage/pages')
  },
]
